import { BaseSelectItem } from 'wbs-components-lib';

import { TicketType } from 'v2/constants';

export const getTicketTypeSelectItems = (): BaseSelectItem[] =>
  Object.values(TicketType).map((type) => ({
    id: type,
    value: type,
  }));
